/* eslint-disable max-len */
import * as React from 'react'
import Svg, {
  G,
  Path,
  Defs,
  LinearGradient,
  Stop,
  ClipPath
} from 'react-native-svg'

function SleepyCalendar() {
  return (
    <Svg width={148} height={116} viewBox="0 0 148 116" fill="none">
      <G clipPath="url(#clip0_3189_20905)">
        <Path
          d="M79.063 114.654c28.498 0 51.6-25.025 51.6-55.895 0-30.87-23.102-55.894-51.6-55.894s-51.6 25.025-51.6 55.894c0 30.87 23.102 55.895 51.6 55.895zM49.242 7.663c1.364-.48 2.11-2.066 1.666-3.543-.443-1.477-1.907-2.285-3.27-1.805-1.364.48-2.11 2.066-1.666 3.543.443 1.477 1.907 2.285 3.27 1.805z"
          fill="#EAEEF9"
        />
        <Path
          d="M107.926 104.757H14.174l17.13-85.36h93.856l-17.234 85.36z"
          fill="#fff"
        />
        <Path
          d="M107.926 104.757H14.174l17.13-85.36h93.856l-17.234 85.36z"
          fill="#D5DAE8"
        />
        <Path
          d="M53.834 104.757H34.42c-3.53 0-6.438-3.261-6.23-7.085l3.115-78.275h4.672l17.857 85.36z"
          fill="url(#paint0_linear_3189_20905)"
        />
        <Path
          d="M145.717 104.757H51.965L36.08 39.191l-.103-.45-4.672-19.343h93.856l4.049 16.756.622 2.587.104.45 15.781 65.566z"
          fill="#fff"
        />
        <Path
          d="M129.832 38.741H35.977l-4.672-19.343h93.856l4.049 16.756.622 2.587z"
          fill="#EFF3FB"
        />
        <Path
          opacity={0.3}
          d="M56.014 33.23c1.834 0 3.322-1.61 3.322-3.598 0-1.988-1.487-3.599-3.322-3.599s-3.323 1.611-3.323 3.599c0 1.988 1.488 3.599 3.323 3.599zM110.833 33.23c1.835 0 3.322-1.61 3.322-3.598 0-1.988-1.487-3.599-3.322-3.599s-3.322 1.611-3.322 3.599c0 1.988 1.487 3.599 3.322 3.599z"
          fill="#ADB6C8"
        />
        <Path
          d="M55.184 31.094c-.623 0-1.142-.562-1.142-1.237s.52-1.237 1.142-1.237c2.284 0 4.672-3.486 4.672-8.772v-.45c-.104-5.173-2.492-8.322-4.672-8.322-2.076 0-4.36 3.036-4.672 7.76h-2.388c.311-5.848 3.322-10.234 6.956-10.234 3.842 0 6.852 4.835 7.06 11.021v.337c.104 6.186-3.01 11.134-6.956 11.134zM109.691 31.094c-.623 0-1.142-.562-1.142-1.237s.519-1.237 1.142-1.237c2.284 0 4.672-3.486 4.672-8.772v-.45c-.104-5.173-2.491-8.322-4.672-8.322-2.077 0-4.361 3.036-4.672 7.76h-2.388c.311-5.848 3.322-10.234 6.956-10.234 3.841 0 6.852 4.835 7.06 11.021v.337c.104 6.186-3.011 11.134-6.956 11.134z"
          fill="#ADB6C8"
        />
        <Path
          d="M2.234 104.645h151.062"
          stroke="#D5DAE8"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          opacity={0.3}
          d="M111.352 64.045c-.623 0-1.039-.562-1.039-1.124 0-.675.416-1.125 1.039-1.125h3.218c.623 0 1.038.562 1.038 1.125 0 .674-.519 1.124-1.038 1.124h-3.218z"
          fill="#D5DAE8"
        />
        <Path
          opacity={0.3}
          d="M67.123 95.76c-.415 0-.83-.337-1.038-.787l-1.661-6.635h-8.202c-.623 0-1.039-.563-1.039-1.125 0-.675.52-1.125 1.039-1.125H63.8l-2.596-9.896h-7.89c-.623 0-1.039-.563-1.039-1.125 0-.675.416-1.125 1.039-1.125h7.267l-2.595-9.896H50.51c-.623 0-1.038-.563-1.038-1.125 0-.675.415-1.125 1.038-1.125h6.956L54.873 51.9h-7.164c-.623 0-1.038-.563-1.038-1.125 0-.675.415-1.125 1.038-1.125h6.54l-1.037-4.048c-.104-.563.207-1.237.727-1.35h.31c.416 0 .832.337 1.04.787l1.245 4.611h8.306c.623 0 1.038.45 1.038 1.125S65.462 51.9 64.84 51.9h-7.683l2.596 9.896h13.081L68.68 45.602c-.104-.563.208-1.237.727-1.35h.312c.415 0 .83.337 1.038.787l1.246 4.611h4.464c.623 0 1.038.45 1.038 1.125s-.519 1.125-1.038 1.125h-3.841l2.595 9.896h8.825c.623 0 1.038.563 1.038 1.125 0 .675-.415 1.125-1.038 1.125h-8.202l2.596 9.896h13.185L85.915 51.9h-2.803c-.623 0-1.039-.563-1.039-1.125 0-.675.52-1.125 1.039-1.125h2.18l-1.038-4.048c-.104-.338 0-.563.104-.9a1.09 1.09 0 01.623-.562h.31c.416 0 .832.337 1.04.787l1.245 4.61h2.18c.623 0 1.038.45 1.038 1.126 0 .674-.415 1.124-1.038 1.124H88.2l2.596 9.897h13.185l-2.596-9.897h-6.748c-.623 0-1.038-.562-1.038-1.124 0-.675.519-1.125 1.038-1.125h5.814l-1.038-4.049c-.104-.562.207-1.237.727-1.35h.311c.415 0 .831.338 1.038.788l1.246 4.61h13.185l-1.037-4.048c-.105-.562.207-1.237.726-1.35h.311c.416 0 .832.338 1.038.788l1.247 4.61h8.098c.623 0 1.038.45 1.038 1.126 0 .674-.415 1.124-1.038 1.124h-7.787l2.596 9.897h7.786c.624 0 1.038.562 1.038 1.125 0 .674-.414 1.124-1.038 1.124h-7.163l2.596 9.897h7.474c.624 0 1.039.562 1.039 1.125 0 .674-.415 1.124-1.039 1.124h-6.852l2.595 9.897h7.061c.623 0 1.037.562 1.037 1.124 0 .675-.518 1.125-1.037 1.125h-6.542l1.558 5.96c.104.563-.208 1.238-.727 1.35h-.311c-.415 0-.831-.337-1.039-.787l-1.661-6.523h-13.184l1.556 5.848c.105.338 0 .563-.103.9-.104.225-.312.45-.623.562h-.312c-.415 0-.831-.337-1.038-.787l-1.661-6.41H97.335l1.558 5.848c.103.562-.208 1.237-.727 1.35h-.311c-.416 0-.831-.338-1.039-.788l-1.66-6.41H81.97l1.557 5.848c.104.562-.208 1.237-.727 1.35h-.311c-.416 0-.83-.338-1.038-.788l-1.662-6.41H66.604l1.557 5.96c.104.338 0 .563-.104.9-.103.225-.311.45-.623.562h-.311zm29.59-9.672h28.551l-2.596-9.896h-13.185l.934 3.598c.104.338 0 .563-.104.9a1.09 1.09 0 01-.623.563h-.311c-.416 0-.831-.338-1.038-.788l-1.039-4.16h-3.945c-.623 0-1.038-.563-1.038-1.126 0-.674.415-1.124 1.038-1.124h3.322l-2.595-9.897H91.002l2.596 9.897h3.218c.623 0 1.038.562 1.038 1.124 0 .675-.415 1.125-1.038 1.125h-2.7l2.596 9.784zm-15.366 0h13.185l-2.595-9.896H78.75l2.596 9.896zm-15.366 0h13.185l-2.595-9.896h-3.842c-.623 0-1.038-.563-1.038-1.125 0-.675.52-1.125 1.038-1.125h3.323l-2.596-9.896H60.271l2.595 9.896h3.426c.623 0 1.039.563 1.039 1.125 0 .675-.52 1.125-1.039 1.125H63.49l2.492 9.896zm42.982-12.146h13.185l-5.71-22.042h-13.289l5.814 22.042z"
          fill="#D5DAE8"
        />
        <Path
          d="M79.278 62.465c-4.315 0-7.939-2.98-9.32-7.263-.344-.931.173-1.862 1.036-2.235.863-.372 1.726.187 2.07 1.118.864 2.793 3.452 4.842 6.214 4.842 2.76 0 5.35-1.862 6.212-4.842.345-.931 1.208-1.49 2.07-1.118.864.373 1.381 1.304 1.036 2.235-1.38 4.47-5.004 7.264-9.319 7.264zM105.335 62.465c-4.314 0-7.938-2.98-9.319-7.263-.345-.931.173-1.862 1.036-2.235.863-.372 1.725.187 2.07 1.118.863 2.793 3.452 4.842 6.213 4.842s5.349-1.862 6.213-4.842c.345-.931 1.208-1.49 2.07-1.118.864.373 1.381 1.304 1.036 2.235-1.38 4.47-5.005 7.264-9.319 7.264zM97.416 85.27c2.193 0 3.97-1.919 3.97-4.284 0-2.366-1.777-4.284-3.97-4.284-2.192 0-3.969 1.918-3.969 4.284 0 2.365 1.777 4.283 3.97 4.283zM14.871 8.004V2.482H34.64v5.522L21.15 25.572h13.721v5.522H14.174v-5.522L27.662 8.004h-12.79zM40.39 42.85v-3.513h12.791v3.514l-8.604 11.294h8.837v3.513H39.926v-3.513L48.53 42.85h-8.14z"
          fill="#ADB6C8"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_3189_20905"
          x1={28.1711}
          y1={62.0643}
          x2={53.8726}
          y2={62.0643}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D5DAE8" />
          <Stop offset={1} stopColor="#9AA3BA" />
        </LinearGradient>
        <ClipPath id="clip0_3189_20905">
          <Path
            fill="#fff"
            transform="translate(.6 .5)"
            d="M0 0H154V115.188H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default SleepyCalendar
